<template>
    <div>
        <div class="product-detail">
            <a href="/">返回首页</a>
            <div class="title-header">
                <div class="header-img">
                    <img src="../../components/images/smartAgriculture.png">
                </div>
                <div class="header-info">
                    <div class="software-name">智慧农业系统</div>
                    <div class="software-company">恒臻科技（大连）有限责任公司</div>
                </div>
            </div>
            <div class="title-content">
                <div class="content-name">应用名称：</div>
                <div class="content-info">
                    智慧农业系统
                </div>
                <div class="content-name" style="margin-top:30px">产品介绍</div>
                <div class="content-info">
                    <!-- 同城CALL骑手版是由恒臻科技（大连）有限责任公司编写的一款APP应用，本应用致力于真实、高效、免费的本地服务，为外卖骑手提供一个良好的服务平台。<br/>
                骑手在登录注册同城CALL骑手版APP后，可以看到发布的所有配送订单，根据自身情况选择接收订单，完成服务。并在服务结束后查看到用户对自身的评价信息。 -->

                    智慧农业系统是一款专为现代化农业大棚种植打造的智能化管控系统，依托智能传感技术、自动控制技术搭建一体化大棚管理平台，致力于解决传统大棚种植人工管控繁琐、<br />
                    环境数据把控不准、水肥浇灌不科学等问题，为农作物生长提供稳定、适宜的生长环境，助力农业种植提质增效、节本降耗。农户及种植管理人员登录系统后，<br />
                    可实时监测大棚内各项环境数据，自主管控水肥设备，精准调控种植环境，实现大棚种植智能化、精细化、规范化管理。
                </div>

                <div class="content-name" style="margin-top:30px">应用详情：</div>
                <div class="content-info">
                    <!-- 同城CALL骑手版是一款专为骑手设计的高效接单与配送管理应用，旨在为骑手提供便捷、智能、安全的工作体验。通过与商家和消费者紧密连接，我们致力于优化配送流程，<br/>
                提升服务效率，确保每一次配送都能准时、准确、安全地完成。 -->
                    智慧农业系统是适配各类种植大棚的智能管控应用，聚焦大棚种植环境监测与设备自动化控制两大核心场景，打破传统人工巡检、手动操作的种植模式。<br />
                    系统可全天候采集大棚内种植环境核心数据，实时同步至管理后台，同时支持农户根据作物生长需求，远程或自动控制施肥、浇水设备，精准调节水肥供给。<br />
                    通过数字化、智能化手段优化大棚种植管理流程，规避人工操作误差，保障农作物生长环境稳定，有效提升农作物产量与品质，降低人工管理成本，实现大棚科学化种植管理。
                </div>
                <div class="content-name" style="margin-top:30px">服务信息：</div>
                <div class="content-info">
                    环境实时监测：全天候自动采集大棚内温度、空气湿度、土壤酸碱度等核心种植环境数据，数据实时更新、精准留存，支持随时查看历史数据，方便农户掌握作物生长环境变化，<br />及时发现环境异常问题。<br />
                    智能水肥管控：支持手动、自动两种模式控制大棚施肥、浇水设备，可根据农作物生长阶段及环境数据，精准调控水肥浇灌量与浇灌时长，避免水肥浪费，满足作物生长所需水分、养分，实现科学水肥管理。<br />
                    数据可视化查看：所有监测环境数据清晰展示，界面简洁直观，农户可快速读取各项参数，无需专业操作，轻松掌握大棚整体环境状态，为种植决策提供数据支撑。<br />
                    便捷设备管理：集中管控大棚浇水、施肥各类设备，设备运行状态实时可查，操作简单高效，替代传统人工手动劳作，大幅降低大棚日常管理人力投入，提升种植管理效率。<br />
                </div>
                <div class="download-wrapper">
                    <button class="download-btn" @click="downloadApk">
                        <span class="download-icon">⬇</span>
                        下载安装包
                    </button>
                </div>

            </div>

            <div class="title-footer">
                <img src="../../components/images/smartAgriculture/1.jpg">
                <img src="../../components/images/smartAgriculture/2.jpg">
                <img src="../../components/images/smartAgriculture/3.jpg">
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CityCallMechanic',
    components: {},
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        downloadApk() {
          const a = document.createElement('a')
          a.href = `/download/智慧农业用户端.apk?t=${Date.now()}`
          a.download = '智慧农业系统.apk'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
    }
}
</script>

<style scoped>
.product-detail {
    width: 70vw;
    margin: 0px 15vw;
    padding: 30px 60px;
    min-width: 400px;
    min-height: 400px;
    background-color: #F0F8FF;
}

.title-header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 200px;
}

.header-img {
    width: 120px;
    height: 120px;
}

.header-img img {
    width: 120px;
    height: 120px;
    border-radius: 20px;
}

.header-info {
    width: calc(100% - 240px);
    margin: 0px 0px 0px 20px;
}

.software-name {
    font-size: 24px;
    font-weight: bold;
}

.software-company {
    font-size: 16px;
    color: dimgray;
}

.title-content {
    width: calc(100% - 120px);
    padding: 10px 60px 50px 60px;
}

.content-name {
    font-size: 18px;
    font-weight: bold;
}

.content-info {
    margin: 10px 0px 0px 0px;
    font-size: 14px;
}

.title-footer {
    width: 100%;
    height: 260px;
    padding: 0px 60px;
}

.title-footer img {
    width: 135px;
    height: 240px;
    margin: 0px 20px;
    border: 1px dashed #999;
}

.download-wrapper {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}

.download-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 30px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    border: none;
    border-radius: 25px;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
    transition: all 0.3s ease;
}

.download-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(79, 172, 254, 0.5);
}

.download-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(79, 172, 254, 0.4);
}

.download-icon {
    margin-right: 8px;
    font-size: 18px;
}
</style>
